// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Y6ee","info":"Note_info__2_IWy","note":"Note_note__3Txlb","actions":"Note_actions__2JmQ2"};